import { Component, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { AuthService } from 'src/app/_core/auth.service';

@Component({
    selector: 'app-magensa-pay-dialog',
    templateUrl: './magensa-pay-dialog.component.html',
    styleUrl: './magensa-pay-dialog.component.scss',
    standalone: false
})
export class MagensaPayDialogComponent implements AfterViewInit {

	loading: boolean = true;
	debugMessages: string[] = [];
	debugText: string;
	hasAVS: boolean = false;

	constructor(
		private sanitizer: DomSanitizer,
		public appService: AppService,
		public entityService: EntityService,
		public authService: AuthService,
		public dialogRef: MatDialogRef<MagensaPayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.onGooglePaymentAuthorized = this.onGooglePaymentAuthorized.bind(this);
		let args = this.data.args;
		this.hasAVS = (args?.paymentVerificationStrategy && args?.paymentVerificationStrategy !== 'none')
	}

	close() {
		this.dialogRef.close({ mode: "cancel" });

	}

	ngAfterViewInit() {

		this.submitToken(this.data.args);
	}

	submitToken(args) {
		console.log("token:", args?.apiKey);
		try {

			let appleMerchantId, googleMerchantId, tecPaymentRequest
			if (this.appService.isIOS && args?.appleMerchantId) {
				/*if (!args.appleMerchantId) {//todo: remove simulation
					args.appleMerchantId = 'AP38354720';
					this.writeLog('Simulating apple merchant id AP38354720');
				}*/
				if (args?.appleMerchantId) {
					appleMerchantId = args?.appleMerchantId;
					tecPaymentRequest = {appleMerchantId: appleMerchantId};
					this.writeLog('Apple pay');
				}
			} else if (args?.googleMerchantId) {
				googleMerchantId = args?.googleMerchantId;
				tecPaymentRequest = {googleMerchantId: googleMerchantId};
				this.writeLog('Google pay');
			}

			const teInstance = window["te-connect"].createTEConnect(args?.apiKey, {
				hideZip: !this.hasAVS,
				tecPaymentRequest: tecPaymentRequest,
				// If you enable 3DS later:
				// threeDs: { challengeNode: document.getElementById('threeDS-container') }
			});
			const teConnect = new window["te-connect-js"].TeConnectJs(teInstance);
			const exampleStyles = {
				base: {
					wrapper: {
						margin: 0,
						padding: 0,
						direction: 'column',
						flexWrap: ''
					},
					variants: {
						inputType: 'outlined',
						inputMargin: 'dense',
						autoMinHeight: true,
					},
					backgroundColor: 'rgb(255, 255, 255)'
				},
				boxes: {
					labelColor: "#1A1A1A",
					textColor: "#1A1A1A",
					borderRadius: 5,
					errorColor: "#CF6679",
					inputColor: '#ffffff'
				}
			};
			teConnect.mountCardEntry('dv-mount', exampleStyles);
			window["teConnect"] = teConnect;

			if (appleMerchantId) {
				this.createApplePay(teConnect);
				//setTimeout(() => {this.createApplePay(teConnect)}, 300);
			} else if (googleMerchantId) {
				setTimeout(() => {this.createGooglePay(teConnect, args)}, 300);
			}

		} catch (e) {

		}
		setTimeout(() => {this.loading = false;}, 2000);
	}

	async onPaymentClicked() {
		try {
			const resp = await window["teConnect"].createPayment();
			if (!resp || resp.error) return;
			this.dialogRef.close({ mode: "success", data: resp });
		} catch (err) {
			console.error('createPayment error', err);
			let response = {
				data: { error: err },
				type: 'magensaError'
			};
			window.parent.postMessage(response, '*');
		}
	}

	// apple pay ----------------------------------------------------------------------->

	isAppleUser = false;
	createApplePay(teConnect) {
		const paymentRequestObject = {
			storeDisplayName: "TEConnect Store",
			applePayVersion: 3,
			currencyCode: "USD",
			countryCode: "US",
			supportedNetworks: ['visa', 'masterCard', 'amex', 'discover', 'jcb'],
			merchantCapabilities: ['supports3DS'],
			total: {
				label: "Test Transaction",
				amount: this.data.total.toString(),
				type: "final"
			}
		};
		this.writeLog('Before tecPrInterface');
		let tecPrInterface;
		try {
			tecPrInterface = teConnect.createTecPaymentRequest(paymentRequestObject);
		} catch (e) {
			this.writeLog('TecPrInterface error');
			this.writeLog(e.toString());
			return;
		}


		try {
			tecPrInterface.canMakePayments().then(canMakePaymentsResult => {
				if (canMakePaymentsResult)
					tecPrInterface.mountTecPrButton("ex-payment-div", {
						applePayOptions: {
							buttonLanguage: 'en',
							buttonType: 'pay',
							buttonStyle: "white-outline"
						}
					});
				else this.writeLog('Can\'t create Apple Pay button. canMakePayments returns null');
			});

			tecPrInterface.listenFor('confirm-token', tokenResp => {

				try {
					this.writeLog(JSON.stringify(tokenResp));
				} catch (e) {
					this.writeLog('Serialize token error');
				}

				const {tokenDetails, completePayment, error} = tokenResp;

				if (error) {
					//Unsuccessful - check message.
					completePayment('failure');
					this.writeLog(error);
				} else {
					//Successful - close user's payment request form with payment success notification.
					completePayment('success');
					this.dialogRef.close({ mode: "success", data: tokenDetails });
					this.writeLog(tokenDetails);

				}
			});

			tecPrInterface.listenFor('cancel-transaction', (cancelEvent) => {
				console.log(cancelEvent);
			});
		} catch (e) {
			this.writeLog(e.toString());
		}

	}

	textTimeout;
	writeLog(message) {
		this.debugMessages.push(message);
	}

	// google pay ----------------------------------------------------------------------->


	async onGooglePaymentAuthorized(paymentData) {
		console.log(paymentData);
		console.log(paymentData.paymentMethodData.tokenizationData.token);
		this.dialogRef.close({ mode: "success", data: JSON.parse(paymentData.paymentMethodData.tokenizationData.token) });
		return true;
	}

	googlePaymentRequestObject: any;
	createGooglePay(teConnect, args) {
		this.googlePaymentRequestObject = {
			apiVersion: 2,
			apiVersionMinor: 0,
			environment: this.appService.appConfig.isDev ? 'TEST' : 'PRODUCTION',
			allowedCardNetworks: ["AMEX", "DISCOVER", "JCB", "MASTERCARD", "MIR", "VISA"],
			merchantName: "TEConnect",
			gatewayId: "__magensa_gateway_id__",
			transactionInfo: {
				totalPriceStatus: 'FINAL',
				totalPrice: this.data.total.toString(),
				countryCode: 'US',
				currencyCode: "USD",
			},
			callbackIntents: ["PAYMENT_AUTHORIZATION"],
			paymentDataCallbacks: {
				onPaymentAuthorized: this.onGooglePaymentAuthorized,
				//onPaymentDataChanged: this.onPaymentDataChanged
			},
			emailRequired: false,
			shippingAddressRequired: false,
			shippingOptionRequired: false,
			/*shippingAddressParameters: {
				allowedCountryCodes: ['US'],
				phoneNumberRequired: true
			},
			//shippingOptionParameters: getGoogleDefaultShippingOptions(),

			environment: "TEST",
			allowCreditCards: true,
			assuranceDetailsRequired: false,
			billingAddressRequired: false,
			billingAddressParameters: {
				format: "FULL",
				phoneNumberRequired: false
			}*/
		}
		let tecPrInterface = teConnect.createTecPaymentRequest(this.googlePaymentRequestObject);
		tecPrInterface.canMakePayments().then( canMakePaymentsResult => {
			if (canMakePaymentsResult)
				tecPrInterface.mountTecPrButton("ex-payment-div", {
					preClick: () => console.log('preClick executed just before payment sheet loads'),
					buttonColor: 'white',
					buttonType: 'order',
					buttonLocale: 'ja',
					buttonSizeMode: 'fill'
				});
			else this.writeLog('Can\'t create Google Pay button. canMakePayments returns null' );
		});
	}

	// apple pay ----------------------------------------------------------------------->






}
